import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from 'apps/new-web/views/component';
import classNames from 'classnames';
import Icon from 'apps/new-web/views/components/icon';
import { StickyContainer, Sticky } from 'react-sticky';
import CHEVRON_DOWN_LINE from '@ifit/react-icons/dist/icons/CHEVRON_DOWN_LINE';

export default class IconToggle extends BaseComponent {

  static get propTypes() {
    return {
      navDown: PropTypes.bool.isRequired,
      expandedSection: PropTypes.object.isRequired,
      iconAnchor: PropTypes.string.isRequired,
      children: PropTypes.node,
      hasStickyNav: PropTypes.bool,
      bottomOffset: PropTypes.number,
      topOffset: PropTypes.number,
      startingY: PropTypes.number
    };
  }

  constructor(props) {
    super(props);

    this.state = { iconsExpanded: false };
  }

  componentDidMount() {
    this.component = ReactDOM.findDOMNode(this);
    this.toggleParent = this.component.querySelector('.icon-toggle-component');
    this.iconContainer = this.component.querySelector('.icon-toggle-container');
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    if (!this.state.iconsExpanded) return;
    this.iconContainer.style.height = 'auto';
  }

  scrollToLocation(location, scrollUp, duration) {
    if (!scrollUp) return;

    const scrollStep = -(window.pageYOffset - location) / (duration / 15);

    const scrollInterval = setInterval(() => {
      if (window.pageYOffset >= location) {
        window.scrollBy(location, scrollStep);
      } else {
        clearInterval(scrollInterval);
      }
    }, 15);
  }

  iconContainerToggle() {
    const iconToggleAnchor = document.querySelector(this.props.iconAnchor);
    const anchorHeight = iconToggleAnchor.offsetHeight;
    const anchorTopOffset = iconToggleAnchor.getBoundingClientRect().top + window.pageYOffset + anchorHeight;
    const anchorTarget = anchorTopOffset - anchorHeight / 2;

    this.iconContainer.style.height = this.state.iconsExpanded ? `${this.iconContainer.scrollHeight}px` : 0;
    window.scrollTo(window.pageXOffset, window.pageYOffset + 1);

    if (this.state.iconsExpanded) return;
    this.scrollToLocation(anchorTarget, window.pageYOffset > anchorTarget, 600);
  }

  handleIconToggle() {
    this.setState({ iconsExpanded: !this.state.iconsExpanded });
    setTimeout(() => {
      this.iconContainerToggle();
    }, 100);
  }

  renderIcon() {
    return (
      <div
        className={ classNames('icon-toggle-switch-container', { 'expanded': this.state.iconsExpanded, 'nav-offset': this.props.navDown, 'has-sticky-nav': this.props.hasStickyNav }) }
      >
        <div className="icon-toggle" onClick={ this.handleIconToggle }>
          <Icon icon={ CHEVRON_DOWN_LINE } color="white" size={ 32 } />
        </div>
      </div>
    );
  }

  render() {
    return (
      <StickyContainer className="icon-toggle-component">
        <Sticky
          topOffset={ this.props.topOffset }
          bottomOffset={ this.props.bottomOffset }
          isActive={ this.state.iconsExpanded }
          style={{ top: this.props.startingY }}
        >
          { this.renderIcon }
        </Sticky>

        { this.props.children }

        <div className="icon-toggle-container">
          { this.props.expandedSection }
        </div>
      </StickyContainer>
    );
  }
}
